<template>
	<Step id="packageOffers" icon="mdi-plus">
		<Loading :active="loading" :is-full-page="true" color="#4caf50" data-cy="loading"></Loading>
		<Section id="name" open>
			<Field typeName="Package" fieldName="name" v-model="modelValue.fields.name" dataCy='packageName' />
			<Field title="SKU">
				<!-- TODO: disable when the package is created..
					TODO: should we even have this enabled EVER here? or should we rather put it with the name editor in the modal?
				-->
				<SkuEditor id="pdSku"
					v-model="modelValue.fields.sku.de"
					:parts="[
						{ id: 'prefix', defaultValue: 'PACKAGETRAVEL' },
						{ id: 'group', defaultValue: '', editable: true },
						{ id: 'location', defaultValue: '', editable: true },
					]"
				/>
			</Field>
		</Section>
		<Section id="channels" open>
			<Field :title="$t('text.salesChannels')" required>
				<PackageSalesChannels v-model="model" :products="products" :salesChannels="salesChannels" />
			</Field>
		</Section>
		<Section id="addedOffers" open>
			<FieldSet id="addedOffers" infoText="addedOffersHelp">
				<AddButtonList buttonText="addedOffers" :options="addedValueOptions" :option-disabled="addedValueOptionsDisabled" :option-disabled-reason="addedValueOptionsDisabledReason" :disabled="allAddedValueOptionsDisabled" @option-click="setProductTypeAndOpenAvDialog" />
				<div :class="{ 'mismatch': salesChannelMismatch }">
					<SectionTable
						:items="addedValueItems"
						:hideFooter="true"
						:columns="[
							// TODO: width does not seem to work right - i think the table treats this as 0 width
							{ id: '', type: 'warning', width: '50px' },
							{ id: 'product', width: '320px' },
							{ id: 'salesChannels', width: '250px', type: 'reduced', limit: 2 },
							{ id: 'type', width: '230px' },
							{ id: 'reduction', title: 'reductionPercent', width: '70px', centered: true },
							{ id: 'redemption', width: '90px', centered: true, type: 'slot' },
							'validity',
							'purchase',
							{ id: '', type: 'options'},
						]"
						:options="[
							{ label: 'text.edit', icon: 'mdi-pencil', action: 'edit' },
							{ label: 'text.editChannel', icon: 'mdi-pencil', action: 'edit-channel' },
							{ label: 'text.delete', icon: 'mdi-delete', action: 'delete' },
							{ label: 'text.moveUp', icon: 'mdi-arrow-up', action: 'moveUp' },
							{ label: 'text.moveDown', icon: 'mdi-arrow-down', action: 'moveDown' },
						]"
						no-data-text="noAdditionalProductsAdded"
						@click-item="editAddedValue"
						@option-edit="editAddedValue"
						@option-edit-channel="editAddedValueChannels"
						@option-delete="deleteAddedValue($event)"
						@option-moveUp="moveUp"
						@option-moveDown="moveDown"
					>
						<!-- <template #warning="{ item }">
							<div v-if="item.addl && item.addl.valid == false" style="padding-left: 5px">
								<v-icon color="orange">mdi-alert</v-icon><b>{{$t('text.invalidCouponConfig')}}</b>
								<v-sheet border="error lg" rounded></v-sheet>
							</div>
						</template> -->
						<template #warning-row="{ item }">
							<div v-if="addedValueValidations && addedValueValidations[item.sku] && !addedValueValidations[item.sku].couponValid">
								<v-tooltip>
									<template v-slot:activator="{ props }">
										<v-icon v-bind="props" color="orange">mdi-alert-circle</v-icon>
									</template>
									<b>{{$t('text.invalidCouponConfig2')}}</b>
									<br />
									<span v-for="error in addedValueValidations[item.sku]?.couponErrors" :key="error">
										<br /> <li> {{$t(`text.${error}`)}} </li>
									</span>
								</v-tooltip>
							</div>
						</template>
						<template #column-redemption="{ item }">
							{{ getRedemption(item) }}
						</template>
					</SectionTable>
				</div>
				<p v-if="addedValueItems?.length && salesChannelMismatch" class="helpText" style="color: orange">{{ $t('text.salesChannelMismatch') }}</p>
				<AddedValueDetailsDialog :modelValue="[ addedValue ]" :linkedEntries="linkedEntries" @update:linkedEntries="$emit('update:linkedEntries', $event)" ref="editAddedValueDialog" :pricingType="pricingType" />
				<AddedValuesConfigDialog ref="addedValuesConfigDialog" v-if="addedValueProducts"
					v-model="model"
					:linkedEntries="linkedEntries"
					:productType="productType"
					@finished="afterAddedValuesConfigDialog"
				/>
				<!-- TODO: removed this? what was this for? we cant assign the computed..
					@mismatch="(val) => salesChannelMismatch = val"
				-->
			</FieldSet>
		</Section>
		<Section v-if="isRailawayPackage" id="transportProducts" open>
			<FieldSet id="transportationProducts" infoText="transportationProductsHelp">
				<AddButton @click="updateTransportProducts" buttonText="transportation" :update="true" />
				<SectionTable
					:columns="[
						'product',
						{ id: 'arrivalDepartureRestrictions', type: 'chip' },
						{ id: 'reduction', title: 'reductionPercent' },
						'validity',
						'purchase',
						{ id: 'actions', type: 'slot', width: '50px' }
					]"
					:items="transportationItems"
					no-data-text="noTransportationProductsAdded"
					:hideFooter="true"
				>
					<template #column-actions="{ item }">
						<IfFeatureFlag flag="FEATURE_RIGI_PD_CHANGES">
						<div class="delete-button-container">
							<v-btn v-if="item.isReturnJourney" 
								icon="mdi-minus-circle-outline" 
								variant="icon"
								size="medium"
								color="#00AEEF"
								class="delete-transport-button"
								@click.stop="deleteTransportationAddedValue(item)"
							/>
						</div>
						</IfFeatureFlag>
					</template>
				</SectionTable>
				
				<!-- Add Return Journey Button -->
				<div v-if="!hasReturnJourney" class="add-return-journey-container">
					<v-tooltip v-if="model.fields.returnTicketSameDay?.de" location="top">
						<template #activator="{ props }">
							<div v-bind="props" class="add-return-journey-button disabled">
								<v-icon color="#ccc" size="20">mdi-plus</v-icon>
								<span class="add-return-journey-text">{{ $t('text.addReturnJourney') }}</span>
							</div>
						</template>
						<span>{{ $t('text.disableReturnTicketSameDayToAddReturnJourney') }}</span>
					</v-tooltip>
					<div v-else class="add-return-journey-button" @click="addReturnJourney">
						<v-icon color="#666" size="20">mdi-plus</v-icon>
						<span class="add-return-journey-text">{{ $t('text.addReturnJourney') }}</span>
					</div>
				</div>
				
				<AddedValueDetailsDialog v-model="transportationProducts" ref="transportProductsDialog" :linkedEntries="linkedEntries" @update:linkedEntries="$emit('update:linkedEntries', $event)" v-if="transportationProducts" :transportationView="true" :title="$t('text.transportProductsTitle')" />
				
				<!-- Return Journey Specific Dialog -->
				<AddedValueDetailsDialog v-model="returnJourneyProduct" ref="returnJourneyDialog" :linkedEntries="linkedEntries" @update:linkedEntries="$emit('update:linkedEntries', $event)" v-if="returnJourneyProduct" :transportationView="true" :title="$t('text.addReturnJourney')" />
			</FieldSet>

			<!-- Return Ticket For The Same Day Switch -->
			<IfFeatureFlag flag="FEATURE_RIGI_PD_CHANGES">
				<FieldSet id="additionalSettingsReturnTicketSameDay">
					<v-tooltip v-if="hasReturnJourney" location="top">
						<template #activator="{ props }">
							<div v-bind="props">
								<Field 
									typeName="Package" 
									fieldName="returnTicketSameDay" 
									v-model="model.fields.returnTicketSameDay" 
									:infoText="$t('text.returnTicketSameDayDescription')" 
									:isOnTheRightSide="true" 
									:disabled="hasReturnJourney"
									:class="['mt-4', { 'disabled-field': hasReturnJourney }]"
								/>
							</div>
						</template>
						<span>{{ $t('text.removeReturnJourneyToEnableReturnTicketSameDay') }}</span>
					</v-tooltip>
					<Field 
						v-else
						typeName="Package" 
						fieldName="returnTicketSameDay" 
						v-model="model.fields.returnTicketSameDay" 
						:infoText="$t('text.returnTicketSameDayDescription')" 
						:isOnTheRightSide="true" 
						class="mt-4"
					/>
				</FieldSet>
			</IfFeatureFlag>
		</Section>

		<DataDialog v-if="addedValue" ref="editAddedValueSalesChannels"
			v-model="addedValue.fields.websites.de"
			:title="$t('text.salesChannels')"
			@update:modelValue="setSalesChannelsForAddedValue"
			:useWrap="true"
		>
			<template #content="{ wrap }">
				<!-- TODO: https://app.zeplin.io/project/604748c2bca41a3e66787ef4/screen/659fed1da16c1ec72109ce93 -->
				<div v-for="(scp, s) of salesChannelProductsLookup" :key="'scp' + s"
					style="display: flex; gap: 10px; align-items: center;"
				>
					<v-checkbox v-model="wrap.model" hide-details :label="scp.salesChannel.name" :value="{ website_id: scp.salesChannel.id, website_name: scp.salesChannel.name }" />
					{{ scp.products.length }} Products
				</div>
			</template>
		</DataDialog>

		<!-- Remove Return Journey Confirmation Dialog -->
		<ConfirmationDialog
			v-model:show="showRemoveTransportDialog"
			:title="$t('text.removeReturnJourneyTitle')"
			:heading="$t('text.removeReturnJourneyTitle')" 
			:message="$t('text.removeReturnJourneyMessage')"
			:confirm-button-text="$t('text.confirm')"
			:cancel-button-text="$t('text.cancel')"
			@confirm="confirmRemoveTransportation"
		/>

		<!-- Add Return Journey Confirmation Dialog -->
		<ConfirmationDialog
			:show="showAddTransportDialog"
			@update:show="showAddTransportDialog = $event"
			title="Add Return Journey"
			heading="Add Return Journey"
			message="Are you sure you want to add the return journey?"
			confirm-button-text="Confirm"
			cancel-button-text="Cancel"
			@confirm="confirmAddTransportation"
		/>
	</Step>
</template>

<script>
import Step from './Step.vue'
import Section from './Section.vue'
import FieldSet from './FieldSet.vue'
import Field from '../../../components/fields/Field.vue'
import SwitchField from '../../../components/fields/SwitchField.vue'
import Table from './Table.vue'
import SectionTable from './SectionTable.vue'
import DataDialog from '@/components/common/DataDialog.vue'
import AddButton from './AddButton.vue'
import Common from '@/mixins/Common.vue'
import AddedValuesConfigDialog from './dialogs/AddedValuesConfigDialog.vue'
import PackageSalesChannels from './PackageSalesChannels.vue'
import AddedValueDetailsDialog from './added-values/AddedValueDetailsDialog.vue'
import Alert from '@/components/common/Alert.vue'
import Application from '../Application.vue'
import SkuEditor from './SkuEditor.vue'
import Loading from 'vue-loading-overlay'
import AddButtonList from './AddButtonList.vue'
import ProductContentExecutive from '../../../../../shared/ProductContentExecutive'
import IfFeatureFlag from '@/components/ifFeatureFlag/IfFeatureFlag.vue'
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue'

export default {
	name: 'OffersStep',
	components: { Section, FieldSet, Field, SwitchField, Step, Table, SectionTable, AddButton, AddedValuesConfigDialog, PackageSalesChannels, DataDialog, AddedValueDetailsDialog, Alert, Application, SkuEditor, Loading, AddButtonList, IfFeatureFlag, ConfirmationDialog },
	mixins: [ Common ],
	emits: [ 'update:linkedEntries', 'update:modelValue' ],
	props: {
		modelValue: Object,
		linkedEntries: Object,
		salesChannels: Array,
		products: Array,
	},
	data() {
		return {
			model: null,
			addedValue: null,
			productType: null,
			addedValueValidations: null,
			loading: false,
			showRemoveTransportDialog: false,
			showAddTransportDialog: false,
			transportToRemove: null,
			returnJourneyProduct: null,
		}
	},
	computed: {
		pricingType() {
			return this.model?.fields?.pricingType?.de
		},
		transportationProducts: {
			get() {
				const transportationProductIds = this.model?.fields?.addedValuesTransportation?.de ?? []
				const transportProducts = transportationProductIds.map(entry => this.linkedEntries[entry.sys.id])
				return transportProducts
			},
			set(value) {
			}
		},
		addedValueProducts: {
			get() {
				return this.model?.fields?.addedValues?.de ?? []
			},
			set(value) {
				this.model.fields.addedValues = { de: value }
			}
		},
		transportationItems() {
			return this.transportationProducts.map((item, index) => {
				// const item = this.linkedEntries[id]

				return {
					id: item.sys.id,
					product: item.fields.name[this.serviceLocale] ?? item.fields.name.de ?? '-',
					arrivalDepartureRestrictions: (() => {
						const arrivalStations = item.fields.arrivalStations?.de || []
						const departureStations = item.fields.departureStations?.de || []
						const allStations = [...arrivalStations, ...departureStations]
						
						if (allStations.length === 0) return '-'
						if (allStations.length <= 4) return allStations.join(', ')
						
						const displayStations = allStations.slice(0, 4)
						const remainingCount = allStations.length - 4
						return displayStations.join(', ') + ` +${remainingCount}`
					})(),
					reduction: item.fields.reductionPercent?.de > 0 ? item.fields.reductionPercent?.de + ' %' : '-',
					validity: `${(item.fields.validDaysBefore.de || item.fields.validDaysAfter.de) ? ((item.fields.transportType.de.toLowerCase() == 'outward' ? '-' : '+') + (item.fields.transportType.de.toLowerCase() == 'outward' ? item.fields.validDaysBefore.de : item.fields.validDaysAfter.de) + ' ' + this.$t('text.daysShort')) : '-'}`,
					purchase: item.fields.required?.de ? this.$t('text.mandatory') : this.$t('text.optional'),
					isReturnJourney: item.fields.transportType.de.toLowerCase() === 'return'
				}
			})
		},
		addedValueItems() {
			return this.addedValueProducts.map(({ sys: { id } }, index) => {
				const item = this.linkedEntries[id]

				let validity
				// NOTE: validityType can be (stay | more | fixed)
				if (item.fields.validityType?.de === 'fixed') validity = this.$t('text.duringStay')
				else if (item.fields.validityType?.de === 'variable') validity = this.$t('text.withinStay')
				else {
					const validDaysBefore = item.fields.validDaysBefore?.de ?? ''
					const vda = item.fields.validDaysAfter?.de
					let validDaysAfter = vda === null || vda === undefined ? '-' : `+ ${ vda }`
					validity = ` - ${ validDaysBefore } | ${ validDaysAfter }`
				}

				return {
					id: item.sys.id,
					product: item.fields.name[this.serviceLocale] ?? item.fields.name.de ?? '-',
					salesChannels: item.fields.sku?.de?.length === 1 ? item.fields.websites?.de?.length > 0 ? item.fields.websites?.de?.filter(website => website.website_name !== 'Configuration').map(website => website.website_name)?.join(', ') : '-' : this.$t('text.multipleProducts'),
					status: item.fields.status?.de ?? '-',
					type: item.fields.type?.de ? this.$t(`text.${item.fields.type.de}`) : '-',
					reduction: this.getReductionsString(item),
					redemption: item.fields.maximumRedemptionCount?.de > 0 ? item.fields.maximumRedemptionCount?.de : '-',
					validity,
					purchase: item.fields.purchase?.de ? this.$t(`text.purchaseTable-${item.fields.purchase.de}`) : '-',
					sortOrder: item.fields.sortOrder?.de ?? 0,
					sku: item.fields.sku?.de?.[0] ?? '-',
					isSkipass: item.fields.skipassProducts?.de?.length > 0,
					hasContingent: item.fields.hasContingent?.de,
				}
			})
		},
		salesChannelProductsLookup() {
			const r = {}
			if (!this.salesChannels) return r
			for (const salesChannel of this.salesChannels) {
				const products = this.products.filter(p => p.product_websites.some(website => website.product_website_id === salesChannel.id))
				r[salesChannel.id] = { salesChannel, products }
			}
			return r
		},
		salesChannelMismatch() {
			if (!this.model) return false

			const salesChannels = this.model.fields.websites.de.map(channel => channel.id)
			if (!this.linkedEntries) return

			let hasExtraSalesChannels = false
			this.model.fields.addedValues.de.forEach(({ sys: { id } }) => {
				const addedValue = this.linkedEntries[id]
				const addedValueSalesChannels = addedValue.fields.websites.de.map(channel => channel.website_id)
				const hasExtra = salesChannels.some(channel => !addedValueSalesChannels.includes(channel))
console.log(addedValue, addedValueSalesChannels, salesChannels, 'hasExtra', hasExtra)

				if (hasExtra) hasExtraSalesChannels = true
			})

			return hasExtraSalesChannels
		},
		isRailawaySkipassPackage() {
			// Since we want to get rid of the separate package type for OV-SKIPASS, we need to compute the logic. Therefore, we check if the package is a railaway package and if it has at least one added value item with a SKU starting with SKIPASS.
			return this.isRailawayPackage && this.addedValueItems?.some(({ isSkipass }) => isSkipass)
			// TODO: replace this statement with the one above when the SKIPASS package type is removed and all Railaway packages are OV packages
			// return this.model?.fields?.packageType?.de === 'package-ov-skipass'
		},
		isRailawayPackage() {
			return this.model?.fields?.packageType?.de === 'package-ov' || this.model?.fields?.packageType?.de === 'package-ov-skipass'
		},
		hasSkipassAV() {
			// Check if the package already has a skipass AV (based on isSkipass flag)
			return this.addedValueItems?.some(item => item.isSkipass)
		},
		hasPackageMarginAV() {
			// Check if the package already has a package margin AV (based on SKU)
			return this.addedValueItems?.some(item => item.sku?.startsWith('ADDON.PACKAGE_MARGIN.'))
		},
		hasReturnJourney() {
			return this.transportationItems.some(item => item.isReturnJourney)
		},
		addedValueOptions() {
			// For OV packages, include PACKAGE_MARGIN option
			if (this.isRailawayPackage) {
				return ['OTHER', 'SKIPASS', 'MRW_CONFIG', 'PACKAGE_MARGIN']
			}
			return ['OTHER', 'SKIPASS', 'MRW_CONFIG']
		},
		addedValueOptionsDisabled() {
			// Skipass is restricted to one per package for railaway packages
			// Package margin is restricted to one per package
			return {
				SKIPASS: this.isRailawayPackage && this.hasSkipassAV,
				PACKAGE_MARGIN: this.hasPackageMarginAV,
			}
		},
		addedValueOptionsDisabledReason() {
			return {
				SKIPASS: this.$t('text.onlyOneSkipassAllowed'),
				PACKAGE_MARGIN: this.$t('text.onlyOnePackageMarginAllowed'),
			}
		},
		allAddedValueOptionsDisabled() {
			// Button is only fully disabled if ALL available options are disabled
			// For OV packages, PACKAGE_MARGIN is never disabled, so button is never fully disabled
			const disabledOptions = this.addedValueOptionsDisabled
			return this.addedValueOptions.every(opt => disabledOptions[opt])
		},
	},
	watch: {
		model: {
			deep: true,
			handler(n) { this.$emit('update:modelValue', n); this.validateCouponConfig() },
		},
		modelValue(n) { this.model = n },
	},
	methods: {
    getReductionsString(linkedEntry) {
      let resultString = ''

      const fields = linkedEntry?.fields
      const reductionPercent = fields?.reductionPercent?.de
      const seasonalDiscounts = fields?.seasonalDiscounts?.de
      const hasSeasonalDiscounts = Array.isArray(seasonalDiscounts) && seasonalDiscounts.length > 0

      // Handle reductionPercent if it's greater than 0
      if (reductionPercent > 0) {
        resultString += `${reductionPercent} %`

        // If there are seasonal discounts, append the count
        if (hasSeasonalDiscounts) {
          resultString += `, + ${seasonalDiscounts.length}*`
        }
      }
      // Handle case with exactly 1 seasonal discount
      else if (hasSeasonalDiscounts && seasonalDiscounts.length === 1) {
        const seasonalReductionPercent = seasonalDiscounts[0]?.fields?.reductionPercent?.de
        if (seasonalReductionPercent >= 0) {
          resultString += `${seasonalReductionPercent} %*`
        }
      }
      // Handle case with multiple seasonal discounts
      else if (hasSeasonalDiscounts && seasonalDiscounts.length > 1) {
        const firstSeasonalReductionPercent = seasonalDiscounts[0]?.fields?.reductionPercent?.de
        if (firstSeasonalReductionPercent >= 0) {
          resultString += `${firstSeasonalReductionPercent} %*, + ${(seasonalDiscounts.length - 1)}*`
        }
      }
      return resultString.length > 0 ? resultString : '-'
    },
		getRedemption({ redemption, hasContingent }) {
			if (redemption === null) return '1x'
			if (redemption === '-') return redemption

			let suffix = ''

			if (hasContingent === 'y') suffix = ' / ps'
			if (hasContingent === 'd') suffix = ' / cd'

			return `${redemption}x${suffix}`
		},
		updateTransportProducts() {
			this.$refs.transportProductsDialog.open()
		},
		async deleteTransportationAddedValue(transportAddedValue) {
			this.transportToRemove = transportAddedValue
			this.showRemoveTransportDialog = true
		},
		async confirmRemoveTransportation() {
			this.loading = true
			try {
				const packageId = this.modelValue.sys.id
				await this.$httpDelete(`/packageTravel/package/${packageId}/addedValue/${this.transportToRemove.id}?clientId=${this.$store.state.selectedClient.sys.id}`)
				
				// Update the model by removing the transport product
				this.model.fields.addedValuesTransportation.de = this.model.fields.addedValuesTransportation.de.filter(
					item => item.sys.id !== this.transportToRemove.id
				)
				
				// Remove from linkedEntries
				delete this.linkedEntries[this.transportToRemove.id]
			} catch (error) {
				console.error('Failed to delete transport product:', error)
			} finally {
				this.loading = false
				this.showRemoveTransportDialog = false
				this.transportToRemove = null
			}
		},
		updateAddedValueProducts() {
			this.$refs.addedValuesConfigDialog.open()
		},
		editAddedValueChannels(item) {
			// TODO: server call to update the sales channels of the underlying product of the added value
			this.addedValue = this.linkedEntries[item.id]
			console.log('editAddedValueChannels', this.addedValue)
			this.$nextTick(() => {
				this.$refs.editAddedValueSalesChannels.open()
			})
		},
		async deleteAddedValue(addedValue) {
			this.loading = true
			const packageType = this.model.fields.packageType?.de
			await this.$httpDelete(`/packageTravel/package/${this.modelValue.sys.id}/addedValue/${addedValue.id}?clientId=${this.$store.state.selectedClient.sys.id}`)
			this.addedValueProducts = this.addedValueProducts.filter((item) => item.sys.id !== addedValue.id)
			delete this.linkedEntries[addedValue.id]
			this.loading = false
		},
		editAddedValue(item) {
			this.addedValue = this.linkedEntries[item.id]
			// TODO: revise this when the linked entries has the sys and fields included
			this.addedValue.id = item.id
			console.log('editAddedValue', this.addedValue)
			this.$nextTick(() => {
				this.$refs.editAddedValueDialog.open()
			})
		},
		async afterAddedValuesConfigDialog(addedValues) {
			// TODO: add added values to our model array
			console.log('afterAddedValuesConfigDialog ', addedValues)
			// we reset the selected array in case it was auto-modified by the MRW configurable dialog
			this.$refs.addedValuesConfigDialog.selected = []
			this.$refs.addedValuesConfigDialog.close()
		},
		async setSalesChannelsForAddedValue() {
			const clientId = this.$store.state.selectedClient.sys.id
			const packageType = this.model.fields.packageType?.de
			// Filter out null or undefined website IDs before sending
			const websiteIds = this.addedValue.fields.websites.de
				.map(website => website.website_id)
				.filter(id => id != null)
			this.$httpPost(`/packageTravel/addedValue/${this.addedValue.sys.id}/websites?clientId=${clientId}&packageType=${packageType}`, {
				websiteIds,
			})
		},
		async moveUp(item) {
			const index = this.addedValueProducts.findIndex(({ sys: { id } }) => id === item.id)
			if (index <= 0) return

			const prev = this.addedValueProducts[index - 1]

			this.swapItems(this.addedValueProducts, index, index - 1)
			this.swapSortOrder(this.linkedEntries[item.id], this.linkedEntries[prev.sys.id])

			item.sortOrder = this.linkedEntries[item.id].fields.sortOrder.de

			await this.upsertAddedValuesOrder(item.id, item.sortOrder, 'moveUp')
		},
		swapItems(array, index1, index2) {
			[array[index1], array[index2]] = [array[index2], array[index1]]
		},
		swapSortOrder(entry1, entry2) {
			[entry1.fields.sortOrder.de, entry2.fields.sortOrder.de] = [entry2.fields.sortOrder.de, entry1.fields.sortOrder.de]
		},
		async moveDown(item) {
			const index = this.addedValueProducts.findIndex(({ sys: { id } }) => id === item.id)
			if (index >= this.addedValueProducts.length - 1) return

			const next = this.addedValueProducts[index + 1]

			this.swapItems(this.addedValueProducts, index, index + 1)
			this.swapSortOrder(this.linkedEntries[item.id], this.linkedEntries[next.sys.id])

			item.sortOrder = this.linkedEntries[item.id].fields.sortOrder.de

			await this.upsertAddedValuesOrder(item.id, item.sortOrder, 'moveDown')
		},
		async upsertAddedValuesOrder(addedValueId, sortOrder, mode) {
			this.loading = true
			try {
				addedValueId = addedValueId.replace('AV_', '')
				const packageId = this.$route.params.id
				const payload = {
					clientId: this.$store.state.selectedClient.sys.id,
					addedValueOrder: { addedValueId, sortOrder },
					mode: mode,
				}
				await this.$httpPut(`/packageTravel/package/${packageId}/addedValuesOrder`, payload)
			} catch (error) {
				console.error('Failed to update added values order:', error)
			}
			this.loading = false
		},
		validateCouponConfig() {
			if (!this.model) return
			let skus = []
			this.model.fields.addedValues.de.forEach(({ sys: { id } }) => {
				const addedValue = this.linkedEntries[id]
				// Only COUPON AVs that are inclusive need to be validated
				if (addedValue.fields.sku?.de?.[0]?.startsWith('COUPON') && addedValue.fields.type.de == 'inclusive' && !addedValue.addl) {
					skus.push(addedValue.fields.sku.de[0])
				}
			})
			this.checkCouponConfig(skus)
		},
		async checkCouponConfig(skus) {
			try {
				if (!skus) return
				const executive = new ProductContentExecutive({ clientId: this.$store.state.selectedClient.sys.id }, this)
				this.addedValueValidations = await executive.validateAddedValueProductsForSkus(skus)
				console.log('addedValueValidations', this.addedValueValidations)
// TODO: map to ui

/*				// res is an array of objects: { sku: string, valid: boolean }[]
				const res = await this.$httpGet(`/packageTravel/package/couponConfig?skus=${skus}&clientId=${clientId}&packageId=${packageId}`)
				this.addedValueProducts.map(({ sys: { id } }, index) => {
					const item = this.linkedEntries[id]
					const found = res.find(({ sku }) => sku === item.fields.sku.de[0])
					if (found) {
						item.addl = { ... item.addl, validConfig: found.valid }
					}
				})*/
			}
			catch (error) {
				console.error('Failed to check coupon config:', error)
			}
		},
		setProductTypeAndOpenAvDialog(productType) {
			this.productType = productType
			this.$nextTick(() => {
				this.updateAddedValueProducts()
			})
		},
		addReturnJourney() {
			this.showAddTransportDialog = true
		},
		confirmAddTransportation() {
			this.createReturnJourneyAV()
		},
		createReturnJourneyAV() {
			const returnJourneyId = 'AV_NEW_RETURN_' + Math.floor(Math.random() * 1000000)
			
			this.returnJourneyProduct = [{
				sys: { id: returnJourneyId },
				fields: {
					name: { de: 'Return Journey' },
					transportType: { de: 'return' },
					sku: { de: ['TRANSPORTATION.TICKET'] },
					roundingPrecision: { de: 1 },
					roundingMode: { de: 'round_half_up' },
					seasonalDiscounts: { de: [] },
					arrivalStations: { de: [] },
					departureStations: { de: [] },
					purchase: { de: 'booking' },
					required: { de: false },
					showPrice: { de: true },
					validDaysAfter: { de: 7 },
					validityType: { de: 'variable' },
					reductionPercent: { de: 0 },
					maximumRedemptionCount: { de: null },
				}
			}]
			
			this.$nextTick(() => {
				this.$refs.returnJourneyDialog.open()
			})
		},

	},
	async mounted() {
		this.model = this.modelValue
	},
}
</script>

<style scoped>
.loading { pointer-events: none; }
.mismatch { border: 2px solid orange; }
.delete-button-container {
	display: flex;
	justify-content: center;
}
.delete-transport-button {
	opacity: 0;
}
tr:hover .delete-transport-button {
	opacity: 1;
	transition: all 0.3s ease;
	transform: scale(1.2);
}
.add-return-journey-container {
	margin-top: 16px;
}
.add-return-journey-button {
	border: 2px dashed #ccc;
	border-radius: 8px;
	padding: 16px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	background-color: #f8f9fa;
	transition: all 0.2s ease;
	cursor: pointer;
}
.add-return-journey-button:hover {
	border-color: #999;
	background-color: #00466030;
}
.add-return-journey-text {
	color: #666;
	font-size: 14px;
	font-weight: 500;
}
.add-return-journey-button.disabled {
	opacity: 0.5;
	cursor: not-allowed;
	pointer-events: auto; /* Ensure tooltip can still trigger */
}
.add-return-journey-button.disabled:hover {
	border-color: #ccc;
	background-color: #f8f9fa;
}
.add-return-journey-text.disabled {
	color: #ccc;
}
.disabled-field {
	opacity: 0.5;
	pointer-events: none;
}
.disabled-field :deep(.v-input) {
	opacity: 0.6;
}
.disabled-field :deep(.v-switch) {
	opacity: 0.6;
}
.disabled-field :deep(.v-label) {
	color: #999 !important;
}

</style>